import Vue from 'vue'
import i18n  from './i18n/index.js';
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/assets/css/globe.css'
import '@/assets/css/media.css'
import '@/assets/css/markdown.min.css'
import { timeago } from '@/utils/dateAgo'
import { dateFormat } from '@/utils/dateFormat'
import Banner from './components/banner/Banner.vue';
import 'swiper/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import highlight from 'highlight.js'
import '@/assets/css/high.min.css'
import 'element-ui/lib/theme-chalk/index.css';

import VueLazyload from 'vue-lazyload'
import utils from './utils/util';

// Vue.prototype.$utils = utils;
Vue.use(utils);
Vue.use(VueAwesomeSwiper)

Vue.component('Banner', Banner);
// 转换时间戳
Vue.filter('timeago', timeago)
Vue.filter('dateFormat', dateFormat)
Vue.prototype.$bus = new Vue()

// 图片懒加载的配置
Vue.use(VueLazyload, {
  loading: require('./assets/img/lazy/lazy.png')
})

// 代码高亮
Vue.use(highlight)
Vue.directive('highlight', (el) => {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    highlight.highlightBlock(block)
  })
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
